import React, { ReactNode } from 'react';
import { Navigate } from 'react-router-dom';

interface PublicRouteProps {
	children: ReactNode;
}

const PublicRoute: React.FC<PublicRouteProps> = ({ children }) => {
	const token = localStorage.getItem('HRMS-token');
	return token ? <Navigate to='/Dashboard' replace /> : children;
};

export default PublicRoute;
